import { Base, getInstanceFromElement } from "@studiometa/js-toolkit";
import { domScheduler } from "@studiometa/js-toolkit/utils";
import { watchLayout, getLayout } from "../store/index.js";
import Resizable from "./Resizable.js";
const layouts = ["top", "right", "bottom", "left"];
class LayoutReactive extends Base {
  /**
   * Config.
   */
  static config = {
    name: "LayoutReactive",
    options: {
      top: String,
      right: String,
      bottom: String,
      left: String
    }
  };
  async mounted() {
    this.switch(await getLayout());
    watchLayout((value) => {
      this.switch(value);
    });
  }
  switch(value) {
    console.log("switch", value);
    domScheduler.read(() => {
      let toAdd = "";
      let toRemove = "";
      layouts.forEach((layout) => {
        if (value === layout) {
          toAdd = this.$options[layout];
        } else if (this.$options[layout]) {
          toRemove += ` ${this.$options[layout]}`;
        }
      });
      toAdd = toAdd.trim();
      toRemove = toRemove.trim();
      if (toRemove.length) {
        domScheduler.write(() => {
          this.$el.classList.remove(...toRemove.split(" "));
        });
      }
      if (toAdd.length) {
        domScheduler.write(() => {
          this.$el.classList.add(...toAdd.split(" "));
        });
      }
      const maybeResizable = getInstanceFromElement(this.$el, Resizable);
      if (maybeResizable) {
        maybeResizable.reset();
      }
    });
  }
}
export {
  LayoutReactive as default
};
//# sourceMappingURL=LayoutReactive.js.map
